import { render, staticRenderFns } from "./ziform.vue?vue&type=template&id=30712708&"
import script from "./ziform.vue?vue&type=script&lang=js&"
export * from "./ziform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports